import React, { ReactNode } from 'react';
import { Space } from 'antd';
import AppButton from '@nxsys/components/AppButton';
import { IconConfirmDelete } from '@nxsys/assets/icons';
import Icon from '@nxsys/components/AppIconImage';
import { StyledModal, StyledTitle } from './index.styled';
import { createRoot, Root } from 'react-dom/client';

export type AppConfirmDeleteDialogProps = {
  title: string | ReactNode;
  open: boolean;
  paragraph?: string | ReactNode;
  onDeny: () => void;
  onConfirm: () => void;
};

export const AppConfirmationDelete = {
  open: ({
    title = '',
    paragraph = '',
    onConfirm = () => {},
  }: {
    title: string | ReactNode;
    paragraph?: string | ReactNode;
    onConfirm?: () => void;
  }) => {
    const container = document.createElement('div');
    document.body.appendChild(container);

    let root: Root | null = createRoot(container);

    const cleanup = () => {
      if (root) {
        root.unmount();
        root = null;
      }
      if (container.parentNode) {
        container.parentNode.removeChild(container);
      }
    };

    const handleDeny = () => {
      cleanup();
    };

    const handleConfirm = () => {
      onConfirm();
      cleanup();
    };

    root!.render(
      <AppConfirmationDeleteModal
        open={true}
        onDeny={handleDeny}
        onConfirm={handleConfirm}
        title={title}
        paragraph={paragraph}
      />,
    );
  },
};

const AppConfirmationDeleteModal: React.FC<AppConfirmDeleteDialogProps> = ({
  open,
  onDeny,
  onConfirm,
  title,
  paragraph = 'Are you sure you want to delete?',
}) => {
  return (
    <StyledModal
      title={null}
      footer={null}
      open={open}
      width={400}
      okText="Confirm"
      cancelText="Cancel"
      // onOk={onConfirm}
      onCancel={onDeny}
    >
      <Icon src={IconConfirmDelete} alt="Delete" />
      <StyledTitle>{title}</StyledTitle>
      {paragraph}
      <Space className="modal-footer" size={12}>
        <AppButton name="Cancel" variant="outlined" onClick={onDeny} />
        <AppButton name="Confirm" onClick={onConfirm} />
      </Space>
    </StyledModal>
  );
};

export default AppConfirmationDeleteModal;
